﻿import { Injectable } from '@angular/core';
import { Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';

import { AuthenticationService } from '../_services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RootGuard implements CanActivate, CanActivateChild {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)  {
        return this.can(route, state);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.can(route, state);
    }

    can(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser && !currentUser.tokenExpired) {
            // authorised so return true
            return this.authenticationService.hasRol('ROLE_ROOT');
        }

        if (currentUser && currentUser.tokenExpired) {
            this.router.navigate(['/change']);
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}

